import { Table } from "@animech/ui";
import { useMemo } from "react";
import { UseArticleTableData } from "src/ui/data/use-article-table";

export const ArticleTable = () => {
	const { header, articles } = UseArticleTableData();

	const rows = useMemo(
		() => articles.map((article) => article.contentArray),
		[articles],
	);

	return <Table header={header} rows={rows} />;
};
